import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import styles from './Doc.module.css';
import { patientActions } from '_actions'
import { getDateMDYYYY } from '_helpers'
import { PdfButton } from '_components';
import { pdfService } from '_services';

class PatientHomeCdvPocDoc extends React.Component {
    openPdf() {
        let newWindow = window.open('/loading.html');
        newWindow.onload = () => {
            pdfService.raw(this.props.doc.id, 2)
                .then(response => response.blob())
                .then(blobby => {
                    let objectUrl = window.URL.createObjectURL(blobby);
                    newWindow.location = objectUrl;
                });
        }
    }

    getIcon1() {
        switch (this.props.doc.noteType) {
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
                if (this.props.doc.status === 2)
                    return (<PdfButton size='extra-small' title='Open PDF' onClick={(e) => this.openPdf()} />);
                else
                    return (<span />);
            default:
                return (<span />);
        }
    }

    openDoc() {
        this.props.openPdf(this.props.doc.id, true, 2);
    }

    render() {
        return (
            <div>
                <div className={styles.doc_wrapper} onClick={() => this.openDoc()}>
                    <div className={styles.doc_row}>
                        <div className={styles.icon}>
                            {this.getIcon1()}
                        </div>
                        <div className={styles.icon} />
                        <div className={styles.icon} />
                        <div className={styles.iconSpace} />
                       
                        <div className={styles.supervisior_icon} />
                        <div className={styles.doc_name}>
                            {this.props.noteType} - POC
                        </div>
                        <div className={styles.doc_dos}>
                            <span className={styles.inline_header}>DOS:</span>{this.props.doc.dos ? getDateMDYYYY(this.props.doc.dos) : ''}
                        </div>
                        <div className={styles.doc_visit}>
                            {this.props.doc.visitNum !== 0 &&
                                <span><span className={styles.inline_header}>Visit:</span>{this.props.doc.visitNum}</span>
                            }
                        </div>
                        <div className={styles.doc_therapist}>
                            {this.props.doc.therapist &&
                                <span><span className={styles.inline_header}>Therapist:</span>{this.props.doc.therapist}</span>
                            }
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        openPdf: bindActionCreators(patientActions.openPdf, dispatch),
    };
}


function mapStateToProps(state, ownprops) {
    return {
        doc: state.entities.cdv[ownprops.id],
        noteType: state.entities.masterData.PTMASTERNOTETYPES[state.entities.cdv[ownprops.id].noteType].MTNAME,
    };
}

const connectedPatientHomeCdvPocDoc = connect(mapStateToProps, mapDispatchToProps)(PatientHomeCdvPocDoc);
export { connectedPatientHomeCdvPocDoc as PatientHomeCdvPocDoc };

